// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"assets_i18n_en_translation_json":"4bb6695ea72b209d28bc","assets_i18n_nl_translation_json":"a3c0fefdcfeaa130da67"}[chunkId] + ".chunk.js";
};